import { Link, useParams } from 'react-router-dom'
import { useApiQuery } from 'grabbitbot-legacy-ui'
import { tradingClient } from '../../api'
import { MarginNotSupported } from './StrategyListPage'
import { StrategyTable } from './StrategyTable'
import { failureText } from '../../api/errorMessages'

/** Equivalent of legacy `V3StrategySearchSpotComponent` (route
 * `strategy/:tradingType/search`, "Strategy Marketplace"):
 * `GET /v3/spot/config/strategy/marketplace` — the public (`vis` 3)
 * strategies. Legacy had no filter UI here either. */
export function StrategySearchPage() {
  const { tradingType = 'spot' } = useParams<{ tradingType: string }>()
  const { data, loading, error } = useApiQuery(() => tradingClient.searchMarketplace(), [])
  if (tradingType !== 'spot') return <MarginNotSupported title="Strategy Marketplace" />
  return (
    <div>
      <div className="portal-page-title">
        <h1>Strategy Marketplace</h1>
        <Link to="/strategy/spot">My strategies</Link>
      </div>
      <div className="portal-card">
        {loading && <p>Loading…</p>}
        {error && <p role="alert">{failureText(error, 'Could not load the marketplace')}</p>}
        {data && <StrategyTable strategies={Array.isArray(data) ? data : []} />}
      </div>
    </div>
  )
}
